import { ENav } from "components/Layout/types";
import { MINIMUM_MAIN_PATH_LENGTH } from "components/Layout/constants";

export const isMatchParentPath = ({
  entityType,
  currentPaths,
  parentPath,
  mainPathLengthMinimum,
}: {
  entityType: ENav;
  currentPaths: string[];
  parentPath: string;
  mainPathLengthMinimum?: number;
}): boolean => {
  const minMainPathLength =
    mainPathLengthMinimum || MINIMUM_MAIN_PATH_LENGTH[entityType];
  const pathsToCheck = [...currentPaths];

  if (!currentPaths.length || pathsToCheck.length < minMainPathLength)
    return false;

  const isMatchWithChildren = parentPath.includes(
    pathsToCheck[pathsToCheck.length - 1]
  );
  if (isMatchWithChildren) return true;

  pathsToCheck.pop();
  if (pathsToCheck?.length >= minMainPathLength) {
    return isMatchParentPath({
      entityType,
      currentPaths: pathsToCheck,
      parentPath,
      mainPathLengthMinimum: mainPathLengthMinimum,
    });
  }

  return false;
};
